<template>
  <div id="TopNav">
    <b-container>
      <b-nav v-b-scrollspy v-if="global.userInfo.accountType == 'beyond'">
        <img src="@/assets/logo_primary.svg" class="logo" />
        <b-nav-item
          v-for="(item, index) in navDataBeyond"
          :key="'nav' + index"
          :href="item.anchor"
          v-scroll-to="item.anchor"
        >
          {{ item.title }}
        </b-nav-item>
      </b-nav>
      <b-nav v-b-scrollspy v-if="global.userInfo.accountType == 'expiring'">
        <img src="@/assets/logo_primary.svg" class="logo" />
        <b-nav-item
          v-for="(item, index) in navDataExpiring"
          :key="'nav' + index"
          :href="item.anchor"
          v-scroll-to="item.anchor"
        >
          {{ item.title }}
        </b-nav-item>
      </b-nav>
      <div class="buttons">
        <div class="contact">
          <p>Contact Us</p>
          <div class="repBox">
            <div class="repInfo">
              <div v-if="global.userInfo.repName != 'United Club'" class="rep-title">Your Account Representative Is</div>
              <div v-if="global.userInfo.repName != 'United Club'" class="rep-name">{{ global.userInfo.repName }}</div>
              <a class="rep-email" :href="'mailto:' + global.userInfo.repEmail">
                {{ global.userInfo.repEmail }}
              </a>
              <div class="rep-phone">{{ global.userInfo.repPhone }}</div>
            </div>
          </div>
        </div>
        <div class="view-invoice" v-if="global.userInfo.accountType == 'beyond'" v-b-modal.beyondModal><p>View Invoice</p></div>
        <a class="pay-now" v-if="global.userInfo.accountType == 'beyond'" href="https://am.ticketmaster.com/broncos/" target="_blank" onclick="return submitHit('pay-now', true);"><p>Pay Now</p></a>
        <div class="renew-now" v-if="global.userInfo.accountType == 'expiring'" v-b-modal.expiringModal><p>Renew Now</p></div>
        <div class="renew-now" v-if="global.userInfo.accountType == 'renewal'" v-b-modal.renewModal><p>Renew Now</p></div>
      </div>
    </b-container>
  </div>
</template>

<script>
  import BeyondPopup from "@/components/global/BeyondInvoicePopup";
  import ExtensionPopup from "@/components/global/ExtensionPopup";
  import { mapState } from "vuex";

  export default {
    name: "TopNav",
    components: {
      BeyondPopup,
      ExtensionPopup
    },
    computed: {
      ...mapState(["global"]),
    },
    data() {
      return {
        navDataBeyond: [
          {
            title: "Home",
            anchor: "#LandingAnchor"
          },
          {
            title: "Amenities \n& Benefits",
            anchor: "#AmenitiesAnchor"
          },
          {
            title: "Seating \nMap",
            anchor: "#MapAnchor"
          }
        ],
        navDataExpiring: [
          {
            title: "Home",
            anchor: "#LandingAnchor"
          },
          {
            title: "Renewal \nOffer",
            anchor: "#RenewalOfferAnchor"
          },
          {
            title: "Amenities \n& Benefits",
            anchor: "#AmenitiesAnchor"
          },
          {
            title: "Seating \nMap",
            anchor: "#MapAnchor"
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  #TopNav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 69px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #111B2E;
    box-shadow: 0 10px 40px 0 rgba(0,0,0,0.15);
    z-index: 9;
    .container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }
    .nav {
      position: relative;
      display: inline-flex;
      align-items: center;
      height: 69px;
      .logo {
        // height: 35px;
        height: 40px;
        object-fit: contain;
        margin-right: 36.8px;
      }
      &-item {
        a {
          font-family: ProximaNova-Semibold;
          font-size: 11px;
          letter-spacing: 0;
          line-height: 14px;
          color: #FFF;
          text-decoration: none;
          white-space: pre-line;
          transition: all 0.5s ease-in-out;
          &:hover {
            color: #F26522;
          }
        }
      }
    }
    .buttons {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      height: 69px;
      .contact {
        cursor: pointer;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 126px;
        min-height: 37px;
        background-color: rgba(255, 255, 255, 0.13);
        &:hover {
          .repBox {
            max-height: 500px;
            opacity: 1;
            transition: all 0.5s ease-in-out;
          }
        }
        p {
          margin: 0 auto;
          font-family: ProximaNova-Semibold;
          font-size: 11px;
          line-height: 14px;
          text-align: center;
          color: #FFF;
        }
        .repBox {
          position: absolute;
          top: 53px;
          right: 0;
          max-height: 0;
          opacity: 0;
          transition: all 0.5s ease-in-out;
          overflow: hidden;
        }
        .repInfo {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          padding: 30px 20px 20px 20px;
          background-color: #FFFFFF;
          .rep-title {
            font-family: Morganite-BlackItalic;
            font-size: 42px;
            color: #002a5c;
            text-transform: uppercase;
            white-space: nowrap;
            margin-bottom: 17px;
          }
          .rep-name {
            font-family: ProximaNova-Semibold;
            font-size: 20px;
            line-height: 20px;
            color: #002a5c;
            margin-bottom: 7px;
          }
          .rep-email {
            font-family: ProximaNova-Semibold;
            font-size: 15px;
            line-height: 23px;
            color: #f26522;
            margin-bottom: 7px;
            text-decoration: none;
            transition: color 0.3s ease-in-out;
            &:hover {
              color: #002a5c;
              transition: color 0.3s ease-in-out;
            }
          }
          .rep-phone {
            font-family: ProximaNova-Semibold;
            font-size: 15px;
            line-height: 23px;
            color: #002a5c;
          }
        }
      }
      .view-invoice {
        cursor: pointer;
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: auto;
        min-height: 37px;
        margin-left: 10px;
        border: 1px solid #F26522;
        p {
          padding: 10px 20px;
          font-size: 26px;
          font-family: Morganite-BlackItalic;
          line-height: 15px;
          text-transform: uppercase;
          text-align: center;
          color: #F26522;
        }
      }
      .pay-now, .renew-now {
        cursor: pointer;
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: auto;
        min-height: 37px;
        margin-left: 10px;
        background-color: #F26522;
        text-decoration: none;
        p {
          padding: 10px 20px;
          font-size: 26px;
          font-family: Morganite-BlackItalic;
          line-height: 15px;
          text-transform: uppercase;
          text-align: center;
          color: #111B2E;
        }
      }
    }
  }
</style>